<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount } from 'vue'
import { useRoute, useRouter } from 'vue-router/composables'
import ConfirmationCheck from '@/assets/icons/ConfirmationCheck.vue'

const route = useRoute()
const router = useRouter()

const secondsLeft = ref(15)
let intervalId: number | null = null

const goToEvent = () => {
  const id = route.params.id
  router.replace({ name: 'Event', params: { id: String(id) } })
}

onMounted(() => {
  intervalId = window.setInterval(() => {
    if (secondsLeft.value <= 1) {
      if (intervalId) clearInterval(intervalId)
      goToEvent()
    } else {
      secondsLeft.value -= 1
    }
  }, 1000)
})

onBeforeUnmount(() => {
  if (intervalId) clearInterval(intervalId)
})
</script>

<template>
  <div class="purchase-complete">
    <div class="card">
      <div class="card-inner">
        <ConfirmationCheck
          class="icon"
          aria-hidden="true"
        />

        <div>
          <h1 class="title">Payment successful</h1>
          <p class="hint">
            You will be returned to the event page in <b>{{ secondsLeft }}</b> seconds.
          </p>
        </div>

        <BKButton
          :href="router.resolve({ name: 'Event', params: { id: String(route.params.id) } }).href"
          white-text
        >
          Return to event page
        </BKButton>
      </div>
    </div>
  </div>
</template>

<style scoped>
.purchase-complete {
  min-height: 70vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}

.card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 836px;
  height: 100%;
  max-height: 716px;
  background: #fff;
  color: #333;
  border-radius: 6px;
  padding: 24px;
  box-shadow: 0 2px 8px rgb(0 0 0 / 10%);
}

.card-inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;
  max-width: fit-content;
}

.icon {
  width: 88px;
  height: 88px;
}

.title {
  font-weight: 500;
  font-size: 20px;
  line-height: 26px;
  text-align: center;
}

.hint {
  margin: 0;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
}
</style>
